export const DIALOG_TYPES_DATA = {
  info: {
    cardAttrs: {
      color: 'white',
    },
    cardTitleAttrs: {
      class: ['accent--text'],
    },
    cardTextAttrs: {
      class: ['dark--text'],
    },
    icon: 'mdi-information',
  },
  warning: {
    cardAttrs: {
      color: 'white',
    },
    cardTitleAttrs: {
      class: ['warning--text'],
    },
    cardTextAttrs: {
    },
    icon: 'mdi-alert',
  },
  error: {
    cardTitleAttrs: {
      class: ['error--text'],
    },
    // cardTextAttrs: {
    //   class: ['error--text'],
    // },
    icon: 'mdi-alert-circle-outline',
  },
  default: {
    cardAttrs: {},
    cardTextAttrs: {},
    icon: '',
  },
};

export default {
  DIALOG_TYPES_DATA,
};
